export default __webpack_public_path__ + "static/media/hello-fresh.ebccde13.png";